<template>
  <div class="signs-docs">
    <section class="signs-docs__documentation" aria-labelledby="firma-escrituras-documentation-title">
      <img
        class="signs-docs__image"
        :src="documentationImage"
        alt="Documentación para firma de escritura"
      >

      <div class="signs-docs__content">
        <DsChip label="Documentación" variant="orange" />
        <div>
          <h2 id="firma-escrituras-documentation-title">Lo que necesitarás para tu proceso</h2>
          <p>Reuné esta documentación para que tu proceso avance sin contratiempos.</p>
        </div>

        <ul>
          <li v-for="document in documents" :key="document.text">
            <span class="signs-docs__document-icon">
              <img :src="document.icon" alt="" aria-hidden="true">
            </span>
            <span>{{ document.text }}</span>
          </li>
        </ul>
      </div>
    </section>

    <section class="signs-docs__recommendations" aria-labelledby="firma-escrituras-recommendations-title">
      <h2 id="firma-escrituras-recommendations-title">Restricciones y recomendaciones</h2>
      <ul>
        <li>Verifica que tus documentos de identificación estén vigentes y actualizados antes de acudir a la cita.</li>
        <li>Es indispensable la presencia de todas las partes involucradas en la operación.</li>
      </ul>
    </section>
  </div>
</template>

<script setup lang="ts">
import documentationImage from '../../../assets/firma-escrituras/documentacion.jpeg'
import identificationIcon from '../../../assets/firma-escrituras/icon-identificacion.svg'
import curpIcon from '../../../assets/firma-escrituras/groupsIcon.svg'
import asitIcon from '../../../assets/firma-escrituras/icon-asistencia.svg'
import DsChip from '../atoms/DsChip.vue'

const documents = [
  { icon: identificationIcon, text: 'Identificación oficial original y vigente (INE o pasaporte)' },
  { icon: asitIcon, text: 'CURP actualizada' },
  { icon: curpIcon, text: 'Asistencia obligatoria de todas las partes involucradas en la operación' }
]
</script>

<style scoped>
.signs-docs { display: flex; flex-direction: column; gap: 40px; }
.signs-docs :deep(.ds-chip) { padding: 8px; color: var(--ds-orange-800); background: var(--ds-orange-50); font-size: var(--ds-subtitle9-size); line-height: 16px; }
.signs-docs h2 { margin: 0; color: var(--ds-purple-900); font-family: var(--ds-font-family-bebas); font-size: 40px; line-height: 38px; font-weight: 700; }
.signs-docs p { margin: 0; color: var(--ds-text-primary); font-size: var(--ds-body3-size); line-height: 24px; }
.signs-docs__documentation { display: flex; flex-direction: column; gap: 24px; padding: 24px 16px; }
.signs-docs__image { width: 100%; aspect-ratio: 1; border-radius: 24px; object-fit: cover; }
.signs-docs__content { display: flex; flex-direction: column; align-items: flex-start; gap: 24px; }
.signs-docs__content > div { display: flex; flex-direction: column; gap: 8px; }
.signs-docs__documentation ul, .signs-docs__recommendations ul { display: flex; flex-direction: column; gap: 24px; margin: 0; padding: 0; list-style: none; }
.signs-docs__documentation li { display: flex; align-items: center; gap: 8px; color: var(--ds-text-primary); font-size: var(--ds-body3-size); line-height: 24px; }
.signs-docs__document-icon { display: grid; flex: 0 0 40px; width: 40px; height: 40px; place-items: center; border-radius: 50%; }
.signs-docs__document-icon img { max-width: 40px; max-height: 40px; }
.signs-docs__recommendations { display: flex; flex-direction: column; gap: 24px; padding: 0 16px; }
.signs-docs__recommendations li { color: var(--ds-text-primary); font-size: var(--ds-body3-size); line-height: 24px; }
.signs-docs__recommendations li::before { content: '•'; margin-right: 8px; }

@media (min-width: 768px) {
  .signs-docs__documentation { display: grid; grid-template-columns: 370px minmax(0, 1fr); align-items: center; padding: 0; }
  .signs-docs__image { height: 454px; aspect-ratio: auto; }
  .signs-docs__recommendations { padding: 0; }
}
</style>
